import { render, staticRenderFns } from "./PatreonLogs.vue?vue&type=template&id=67a99ce3&"
import script from "./PatreonLogs.vue?vue&type=script&lang=js&"
export * from "./PatreonLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports